import { Component, OnInit, Input } from '@angular/core';
import { bodyComponent } from '../components/body.component';


@Component({
  selector: 'app-expedientes',
  templateUrl: './expedientes.component.html',
  styleUrls: ['./expedientes.component.css']
})
export class ExpedientesComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

 @Input() expedientes: any = [];



}



// WEBPACK FOOTER //
// /Users/usuario/Desktop/duran/duran-web/src/app/expedientes/expedientes.component.ts